import React, { useState } from "react";
import contactImage from "../../assets/contact-img.webp";
import { db } from "../../firebase_config";
import { collection, addDoc } from "firebase/firestore";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [formData, setFormData] = useState({
        phone: "",
        fullName: "",
        email: "",
        message: "",
    });
    const originalUrl = "https://www.google.com/maps?q=Europe&output=embed"

    const postDataToFirestore = async () => {
        try {
            setButtonLoading(true)
            // const data = {
            //     email: emailAddress,
            //     timestamp: new Date(), // Optional: Add a timestamp
            // };

            // Reference the "contact_us" collection in Firestore
            await addDoc(collection(db, "contact_us"), formData);
            setButtonLoading(false)
            setFormData({
                phone: "",
                name: "",
                email: "",
                message: "",
            });
            toast.success('Thank you! Your message has been received. Our team will contact you soon.', {
                position: "top-right",
                autoClose: 3000, // Auto close after 3 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light", // Use "dark" for a dark theme
                className: "custom-toast"
            });
        } catch (error) {
            setButtonLoading(false)
            console.error("Error adding document: ", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value, // update the specific field
        }));
    };

    const handleClick = (e) => {
        e.preventDefault();
        // console.log("handleClick : " + formData.message);
        postDataToFirestore()
    };
    return (
        <section id="contact">
            <div className="contact-container">
                <h2 className="h1-48-600">
                    Contact <span>Us</span>
                </h2>
                <p className="contact-subtitle">Submit a request or call us</p>
                <div className="contact-form-content">
                    <form className="contact-form" onSubmit={handleClick}>
                        <input type="text"
                            placeholder="Full Name"
                            name="fullName"
                            className="contact-form_input-field"
                            onChange={handleChange}
                            value={formData.fullName}
                            required
                        />
                        <div className="input-group">
                            <input type="email"
                                name="email"
                                placeholder="Email address"
                                className="contact-form_input-field"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <input type="tel"
                                placeholder="Phone number"
                                name="phone"
                                className="contact-form_input-field"
                                onChange={handleChange}
                                value={formData.phone}
                                required
                            />
                        </div>
                        <textarea placeholder="Message"
                            className="contact-form_input-field textarea"
                            name="message"
                            maxLength={2000}
                            onChange={handleChange}
                            value={formData.message}
                            required
                        ></textarea>
                        <div className="contact-button-wrapper">
                            <button type="submit" className="filled-button"
                            // onClick={(e) => {
                            //     e.preventDefault();
                            //     handleClick("Hello from the button!");
                            // }}
                            >
                                {buttonLoading ? (
                                    "Sending ... "
                                ) : (
                                    "Send Message"
                                )}
                            </button>
                        </div>
                    </form>
                    <img src={contactImage} alt="Contact Us" className="contact-image" />
                </div>
                <div className="map-container">
                    <h2 className="h1-48-600" style={{ textAlign: 'start', paddingTop: "20px" }}>
                        Contact <span>Us</span>
                    </h2>
                    <iframe
                        title="Google Map"
                        className="map"
                        src={originalUrl}
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        </section>

    );
};

export default Contact;
